import formatBooking from '../utils/formatBooking';

export default function tourDateSummary(slot = null) {
  const messageHeader = "Your self-tour appointment";
  let message = "\u00A0";

  if (slot) { 
    message = formatBooking(slot);
  }

  return `
    <p class="nhs-o-typography--sans-body-1-small-regular nhs-u-color--black-1000 nhs-u-margin--bottom-200">
      ${messageHeader}
    </p>
    <p class="nhs-o-typography--sans-subhead-2-large-regular nhs-u-color--black-1000 nhs-c-datepicker__information">
      ${message}
    </p>`;
}